import { DreamValue, Navbar2Element } from '@typedream/core';
import { PlateRenderElementProps } from '@udecode/plate-core';
import { createContext } from 'react';

export const NavbarMenuItemContext = createContext<
  PlateRenderElementProps<DreamValue, Navbar2Element>
>({} as any);
